package cz.lhoracek.mapl.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.material3.FilledTonalButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.dp
import mapl.composeapp.generated.resources.Res
import mapl.composeapp.generated.resources.minus
import mapl.composeapp.generated.resources.plus
import org.jetbrains.compose.resources.stringResource

@Composable
fun NumberStepper(
    valueLabel: String,
    onDecrement: () -> Unit,
    onIncrement: () -> Unit,
    modifier: Modifier = Modifier,
    decrementEnabled: Boolean = true,
    incrementEnabled: Boolean = true,
    valueStyle: TextStyle = MaterialTheme.typography.titleMedium,
    valueContent: @Composable RowScope.() -> Unit = {
        Text(valueLabel, style = valueStyle)
    },
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        FilledTonalButton(onClick = onDecrement, enabled = decrementEnabled) {
            Text(stringResource(Res.string.minus))
        }
        valueContent()
        FilledTonalButton(onClick = onIncrement, enabled = incrementEnabled) {
            Text(stringResource(Res.string.plus))
        }
    }
}